export const getCellCoordinates = (item: string) => `${Number(item.split('.')[2])} ${Number(item.split('.')[3])}`;
